import { useState, useRef, useCallback } from 'react';
import { useLazyGetDictionaryQuery } from '../../Translations/api/dictionariesApiSlice';



const useFetchDictionariesByIds = () => {
  const [ dictionaries, setDictionaries ] = useState([]);
  const [ lazyTrigger ] = useLazyGetDictionaryQuery();
  const triggerRef = useRef(lazyTrigger);

  const fetchDictionaries = useCallback(async (dictionaryIds = []) => {
    if (!dictionaryIds.length) {
      setDictionaries([]);
      return;
    }

    const results = await Promise.all(
      dictionaryIds
        .filter(Boolean)
        .map(async (id) => {
          try {
            return await triggerRef.current({
              id,
              include: 'translations,structure,structure.fields.translations',
            }).unwrap();
            // eslint-disable-next-line no-unused-vars
          } catch (error) {
            return null;
          }
        }),
    );

    setDictionaries(results.filter(Boolean));
  }, []);

  return [ dictionaries, fetchDictionaries ];
};

export default useFetchDictionariesByIds;
